module.exports = __webpack_public_path__ + "static/media/drafts.inactive.53ecfa47.svg";